export default __webpack_public_path__ + "static/media/icon-group-3.3.f6406f66.png";